import React from "react"
import {useAccessToken} from "../../../../services/auth"
import useAsyncResultIdle from "../../../../hooks/useAsyncResultIdle"

import {Application, resubmitBusinessApplication} from "../../../../resources/application"
import ConfirmationModalContent from "../ConfirmationModalContent"
import {
	ReevaluatedBusinessApplicationData,
	ReevaluatedBusinessApplicationDataRequest,
} from "../../Forms/ReevaluateBusinessForm/ReevaluateBusinessForm"

export default function ReevaluateBusinessApplicationConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	application: Application
	enableReevaluateApplication: boolean
	reevaluatedData: ReevaluatedBusinessApplicationData
}) {
	const {close, onSuccess, application, enableReevaluateApplication, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateBusinessRequest, setUpdateBusinessRequest] = useAsyncResultIdle(resubmitBusinessApplication)

	const handleSubmit = (reason: string) => {
		const data = {
			phone: reevaluatedData.phone,
			address: reevaluatedData.address,
			ein: reevaluatedData.ein,
			website: reevaluatedData.hasNoWebsite ? null : reevaluatedData.website,
			dba: reevaluatedData.dba,
			name: reevaluatedData.name,
			businessVertical: reevaluatedData.businessVertical,
			yearOfIncorporation: reevaluatedData.yearOfIncorporation,
			numberOfEmployees: reevaluatedData.numberOfEmployees,
			annualRevenue: reevaluatedData.annualRevenue,
			stockSymbol: reevaluatedData.stockSymbol,
			cashFlow: reevaluatedData.cashFlow,
		} as ReevaluatedBusinessApplicationDataRequest

		setUpdateBusinessRequest(accessToken, application, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateBusinessRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={enableReevaluateApplication}
		/>
	)
}
